import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UIRouterModule } from '@uirouter/angular';

import { TranslateModule } from '@ngx-translate/core';

import { VbBtnLinkDirective } from './VbBtnLink.Directive';
import { VbBtnPrimaryDirective } from './VbBtnPrimary.Directive';
import { VbBtnSecondaryDirective } from './VbBtnSecondary.Directive';
import { VbBtnWhiteDirective } from './VbBtnWhite.Directive';
import { VbToggleButtonComponent } from './VbToggleButton.Component';
import { VbUiBtnDangerDirective } from './VbUiBtnDanger.Directive';
import { VbUiBtnFabDirective } from './VbUiBtnFab.Directive';
import { VbUiMultiSelectBtnComponent } from './VbUiMultiSelectBtn.Component';
import { VbUiRadioBtnDirective } from './VbUiRadioBtnAngular.Directive';
import { VbUiRadioBtnGroupDirective } from './VbUiRadioBtnGroupAngular.Directive';

const declarations = [
	VbBtnLinkDirective,
	VbBtnPrimaryDirective,
	VbBtnSecondaryDirective,
	VbBtnWhiteDirective,
	VbToggleButtonComponent,
	VbUiBtnDangerDirective,
	VbUiBtnFabDirective,
	VbUiMultiSelectBtnComponent,
	VbUiRadioBtnDirective,
	VbUiRadioBtnGroupDirective
];

@NgModule({
	declarations: [
		declarations
	],
	exports: [
		declarations
	],
	imports: [
		CommonModule,
		FormsModule,
		UIRouterModule,
		TranslateModule
	]
})
export class ButtonsAngularModule { }
